import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import ArticleEntries from "./components/ArticleEntries";
import StatsSection from "./components/StatsSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import { WebSiteSchema } from "@/components/base/SchemaOrg";

const SITE_DOMAIN = typeof import.meta !== "undefined" && (import.meta as Record<string, unknown>).env ? ((import.meta as Record<string, Record<string, string>>).env.VITE_SITE_URL ?? "https://sugargoospreadsheet.delivery") : "https://sugargoospreadsheet.delivery";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <WebSiteSchema
        siteName="Sugargoo Spreadsheet"
        siteUrl={SITE_DOMAIN}
        searchUrlTemplate={`${SITE_DOMAIN}/guide/{search_term_string}`}
      />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <ArticleEntries />
        <StatsSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}